// components/Markdown/index.js
import React from 'react';
import PropTypes from 'prop-types';

const Markdown = ({ value }) => {
  if (!value) return null;

  // pre-rendered HTML from backend
  if (value.code) {
    return (
      <div className="">
        <div
          className="content max-w-4xl mx-auto"
          dangerouslySetInnerHTML={{ __html: value.code }}
        />
      </div>
    );
  }

  // raw markdown fallback (rare)
  return (
    <div className="">
      <div className="content max-w-4xl mx-auto whitespace-pre-wrap">
        {value}
      </div>
    </div>
  );
};

Markdown.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ code: PropTypes.string.isRequired }),
  ]).isRequired,
};

export default Markdown;
